<template>
<div v-if="loader">
      <img
        src="../../../../assets/img/loader.svg"
        alt="loader"
        class="sa-loader sa-loader-top"
      />
    </div>
  <div v-else class="sa-mob-cont sa-mob-radio">
    <button class="sa-btn-back"  @click="$parent.referIV=false">
      <i class="icon-arrow-left"></i>
    </button>
    <h6 class="sa-card-tit sa-ref-tit">Refer to IV</h6>
    <div class="sa-physio-radio sa-radio-btn">
      <span v-for="(iv, i) in ivList" :key="i">
        <input type="radio" :id="iv.tsk_id" :name="iv.tsk_nm" v-model="selected" :value="iv.tsk_id"  />
        <label :for="iv.tsk_id" class="sa-mb30">{{iv.tsk_nm}}</label></span
      >
    </div>
    <div class="sa-ftr-btn">
      <button :disabled="selected && selected.length <= 0" class="sa-btn sa-btn-large sa-btn-primary sa-btn-block-xs" @click="referIV()">
        Continue
      </button>
    </div>
  </div>
</template>
<script>
import { pro_url } from "../../../../../config/endpoints";
export default {
  props:["iv"],
    data(){
        return{
            selected:[],
            ivList:[],
            searchName:'',
            loader: false
        }
    },
    methods: {
      getIV() {
        let _self = this
         _self.loader = true;
        _self.$store.dispatch("httpPost", {
            uri: `${pro_url}/refer/treatmentDetails`,
            body: {
                "mtype": 7,  
                "limit": 1000,
                "page": 1,
                "name": _self.searchName,
                "prd_id":'ST032'
            }
            }).then(response => {
            if (response && response.status === 1000) {
              console.log(response,'responseresponseresponseresponse')
               _self.loader = false;
                _self.ivList = response.data.data 
            }
        })
      },
      referIV () {
        this.loader = true
        let _self = this
        _self.patDetails = JSON.parse(_self.$localStorage.get('patDetails'))
        _self.$store.dispatch('httpPost', {
            uri: `${pro_url}/refer/addTreatmentReferal`,
            body:{
            "apnt_id": _self.patDetails.apnt_id,
            // "pid": _self.patDetails.pid,
            "uid": _self.patDetails.refDoctor || "",
            stid: _self.patDetails.stid || '',
            dept_id: _self.patDetails.dept_id || '',
            "pkg_id": _self.patDetails.refPackages || [],
            "tsk_id": _self.patDetails.refNurse,
            "tst_id": _self.patDetails.refTests || [],
            "trtmnt_id": _self.patDetails.refPhysio || [],
            'radiology':  _self.patDetails.radiology || [],
             "covid": _self.patDetails.covid || [],
             "vaccination": _self.patDetails.vaccination || [],
            "hemodialysis": _self.patDetails.hemodialysis || [],
            "vitamin_iv_drip": [_self.selected],
            ref_doctorId : _self.patDetails.ref_doctorId || ''
            }
        }).then(response => {

            _self.loader = false
            if (response && response.status === 1000) {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: "Referred Vitamin IV Drip Tasks successfully",
                class: "sa-a-success"
            });
            this.$parent.referIV = false
            this.$parent.getReferralData();
            } else {
            _self.$store.dispatch("SET_ALERTMESSAGE", {
                msg: `${response.desc}. Something went wrong. Please try again or contact operations team`,
                class: "sa-a-danger"
            });
            }
        })      
    }
    },
    mounted () {
      this.selected = (this.iv && this.iv.length )? this.iv[0]: []
      this.getIV()
    }
}
</script>